<template>
  <v-app>
    <v-toolbar app extended extension-height="2"
               v-if="$route.name !== 'login'">
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-toolbar-title class="headline text-uppercase">
        <span>Learn</span>
        <span class="font-weight-light">Language.today</span>
      </v-toolbar-title>
      <v-progress-linear :active="isLoading" slot="extension" height="2" :indeterminate="true" class="ma-0"></v-progress-linear>
    </v-toolbar>

    <v-navigation-drawer
            v-model="drawer"
            fixed
            app
            v-if="$route.name !== 'login'"
    >
      <v-list dense>
        <v-list-group
                v-for="item in dictionaryMenu"
                :key="item.title"
                v-model="item.active"
                :prepend-icon="item.action"
        >
          <template v-slot:activator>
            <v-list-tile>
              <v-list-tile-action>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </template>

          <v-list-tile
                  v-for="subItem in item.items"
                  :key="subItem.title"
                  :to="subItem.path"
          >
            <v-list-tile-action>
              <v-icon>{{ subItem.action }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ subItem.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile v-if="item.sourceDictionary" @click="doShowTranslationDictionaryDialog(item.sourceDictionary)">
            <v-list-tile-action>
              <v-icon></v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Add locale</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-group
                  no-action
                  sub-group
                  v-for="subGroup in item.groups"
                  :key="subGroup.title"
                  v-model="subGroup.active"
                  :prepend-icon="subGroup.action"
          >
            <template v-slot:activator>
              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title>{{ subGroup.title }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </template>

            <v-list-tile
                    v-for="subItem in subGroup.items"
                    :key="subItem.title"
                    :to="subItem.path"
            >
              <v-list-tile-action>
                <v-icon>{{ subItem.action }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{ subItem.title }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list-group>

        </v-list-group>
        <v-list-tile @click="showSourceDictionaryDialog = true">
          <v-list-tile-action>
            <v-icon>mdi-book-multiple-plus</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Add dictionary</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile v-for="item in menu" :key="item.title" :to="item.path" :href="item.href">
          <v-list-tile-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>

    <v-content>
      <router-view/>
    </v-content>
    <SourceDictionaryDialog v-model="showSourceDictionaryDialog"></SourceDictionaryDialog>
    <TranslationDictionaryDialog v-model="showTranslationDictionaryDialog" :sourceDictionary="sourceDictionary"></TranslationDictionaryDialog>
  </v-app>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { API_URL } from './common/config'
import SourceDictionaryDialog from './components/SourceDictionaryDialog'
import TranslationDictionaryDialog from './components/TranslationDictionaryDialog'

export default {
  name: 'App',
  components: { TranslationDictionaryDialog, SourceDictionaryDialog },
  data () {
    return {
      drawer: true,
      showSourceDictionaryDialog: false,
      showTranslationDictionaryDialog: false,
      sourceDictionary: {},
      dictionaryMenu: [],
      menu: [
        { path: '/languages', title: 'Languages', icon: 'language' },
        { href: `${API_URL}backup`, title: 'Download Database', icon: 'mdi-database-export' }
      ]
    }
  },
  computed: {
    ...mapState([
      'dictionary',
      'sourceDictionaries'
    ]),
    ...mapGetters([
      'isLoading'
    ])
  },
  created () {
    this.generateDictionaryMenu()
  },
  watch: {
    sourceDictionaries: {
      handler () {
        this.generateDictionaryMenu()
      },
      deep: true
    }
  },
  methods: {
    doShowTranslationDictionaryDialog (sourceDictionary) {
      this.sourceDictionary = sourceDictionary
      this.showTranslationDictionaryDialog = true
    },
    generateDictionaryMenu () {
      this.dictionaryMenu = this.sourceDictionaries.map(sourceDictionary => {
        const path = `/sources/${sourceDictionary.id}`
        return {
          path,
          title: sourceDictionary.name,
          icon: 'book',
          active: this.$route.name === 'sources' && this.$route.params.sourceDictionaryId === sourceDictionary.id,
          sourceDictionary,
          items: [
            ...this.dictionaryAction(path)
          ],
          groups: sourceDictionary.translationDictionaries.map(translationDictionary => {
            const transPath = `/dictionary/${translationDictionary.id}`
            return {
              path: transPath,
              title: translationDictionary.name,
              icon: '',
              active: translationDictionary.id === this.translationDictionaryId,
              items: this.dictionaryAction(transPath)
            }
          })
        }
      })
      this.dictionaryMenu.unshift({
        path: '/base-words',
        title: 'Base Dictionary',
        icon: 'home',
        active: this.$route.name === 'base-words',
        items: [
          { path: `/base-words`, title: 'Words', icon: 'font_download' },
          { path: `/sources/en/sections`, title: 'Sections', icon: 'category' },
          { path: `/sources/en/categories`, title: 'Categories', icon: 'category' }
        ]
      })
    },
    dictionaryAction (path) {
      return [
        { path: `${path}/words`, title: 'Words', icon: 'font_download' },
        { path: `${path}/alphabet`, title: 'Alphabet', icon: 'font_download' },
        { path: `${path}/sections`, title: 'Sections', icon: 'category' },
        { path: `${path}/categories`, title: 'Categories', icon: 'category' }
      ]
    }
  }
}
</script>

<style>
  .v-toolbar__extension {
    padding: 0;
  }
</style>
